import React, { useState } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { GetStaticProps } from 'next/types';
import { Button } from '@components/atoms/Button/Button';
import { HeaderSection } from '@components/organisms/Authentication/HeaderSection/HeaderSection';
import LoginFlow, { LoginStep } from '@components/organisms/Authentication/LoginFlow/LoginFlow';
import { SectionWrapper } from '@components/organisms/Authentication/SectionWrapper/SectionWrapper';
import { DefaultOnlyLogo } from '@components/templates/layouts/DefaultOnlyLogo';

const Login = () => {
  const [step, setStep] = useState<LoginStep>('start');
  const router = useRouter();

  const steps = {
    start: {
      title: 'Erlebe TV-MEDIA jetzt in vollen Zügen!',
      content: (
        <>
          Melde Dich an oder erstelle einen kostenlosen Account.
          {/* <button
            onClick={() => {
              setStep('register');
            }}
            className="link inline"
          >
            erstelle einen kostenlosen Account.
          </button> */}
        </>
      ),
    },
    get login() {
      return this.start;
    },
    unconfirmed: {
      title: 'Account noch nicht aktiviert.',
      content: (
        <>
          <div className="pt-6">
            Dein E-Mail wurde noch nicht bestätigt. Bitte überprüfe Deinen Posteingang (und Spam) und bestätige den
            Link, den wir Dir nochmals zugesendet haben.
          </div>
        </>
      ),
    },
    unconfirmed_error: {
      title: 'Fehler - Account noch nicht aktiviert.',
      content: (
        <>
          <div className="pt-6">
            Leider ist beim Versuch, Dir den Aktivierungslink zuzusenden ein Fehler aufgetreten, bitte probiere es in
            wenigen Minuten nochmals.
          </div>
        </>
      ),
    },
    register: {
      title: 'Erstelle einen kostenlosen Account.',
      content: 'Gib Deine E-Mail-Adresse ein und wähle ein Passwort.',
    },
    registerName: {
      title: 'Sag uns noch, wie Du heißt.',
      content:
        'Bitte gib Deinen Vor- und Nachnamen an. Bist Du bereits Kunde für unser Print-Abo, dann kannst Du diesen hier verknüpfen.',
    },
    registrationFinish: {
      title: 'Fast geschafft!',
      content: (
        <>
          <div className="pt-6">
            Du erhältst in Kürze eine Bestätigungsmail. Bitte befolge die darin enthaltenen Anweisungen, um Deinen
            Account zu bestätigen.
          </div>
          <Button buttonStyle="primary" link="/" title="Zur Startseite" classProps={{ root: 'mt-16 w-full' }} />
        </>
      ),
    },
    nopassword_error: {
      title: 'Kein Passwort angegeben.',
      content: (
        <>
          <div className="pt-6">
            Dein Account hat noch kein Passwort gesetzt - bitte setze dieses, indem Du auf den untenstehenden Button
            klickst.
          </div>
          <Button
            buttonStyle="primary"
            link="/auth/reset"
            title="Password setzen"
            classProps={{ root: 'mt-8 w-full' }}
          />
        </>
      ),
    },
  };

  function loginSuccessCallback() {
    router.push(router.query?.callbackUrl ? router.query.callbackUrl.toString() : '/');
  }

  const activeStep = step in steps ? steps[step] : null;

  return (
    <>
      <Head>
        <title>TV-Media Login</title>
        <meta name="description" content="TV-Media Login" />
      </Head>
      <SectionWrapper>
        <HeaderSection title={activeStep?.title}>{activeStep?.content}</HeaderSection>
        <LoginFlow step={step} onStepChange={(step) => setStep(step)} loginSuccessCallback={loginSuccessCallback} />
      </SectionWrapper>
    </>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};

Login.PageLayout = DefaultOnlyLogo;
export default Login;
